<div class="main-content">
    <div class="row">

        <div class="col-12 ">
            <mat-card style="box-shadow: none !important;">
                <mat-card-content style="padding: 15px;">
                    <div class="container mainContentNew" style="height: 80vh">
                        <div class="chat-container">
                            <div class="chat-header">
                                <div style="vertical-align: middle; " class="d-flex">
                                    <mat-icon class="chat-back-button" (click)="goBack()">arrow_back</mat-icon>
                                    <span class="chat-title">
                                        #{{ ticket.id }} - {{ticket.messageSubject}}
                                    </span>
                                </div>

                                <span class="chat-status-closed" *ngIf="ticket && ticket.status && ticket.status == 'CLOSED'">{{ ui.capitalizeFirstLetter(ticket.status) }}</span>
                                <span class="chat-status" *ngIf="ticket && ticket.status && ticket.status == 'OPEN'">{{ ui.capitalizeFirstLetter(ticket.status) }}</span>
                            </div>
                            <div class="chat-body" #scrollContainer>
                                <ng-container *ngFor="let d of ticket.walletSupportDetails">
                                    <ng-container *ngIf="d.createdBy != user.email">
                                        <div class="chat-message received">
                                            <p [innerText]="ui.decodeHtmlEntities(d.message)"></p>
                                            <p *ngIf="d.walletSupportAttachment">
                                            <span (click)="downloadAttachmentFromAdmin(d.walletSupportAttachment.id, d.walletSupportAttachment.fileAttachment)" class="attachment">
                                                <mat-icon>attachment</mat-icon> Download attachment
                                            </span>
                                            </p>
                                        </div>
                                        <span class="received-time">{{ d.createdAt | date : "MM/dd/y hh:mm:ss" }}</span>
                                    </ng-container>

                                    <ng-container *ngIf="d.createdBy == user.email">
                                    <div class="chat-message sent">
                                        <p [innerText]="ui.decodeHtmlEntities(d.message)"></p>
                                        <p *ngIf="d.walletSupportAttachment">
                                            <span (click)="downloadAttachment(d.walletSupportAttachment.id, d.walletSupportAttachment.fileAttachment)" class="attachment">
                                                <mat-icon>attachment</mat-icon> Download attachment
                                            </span>
                                        </p>
                                    </div>
                                        <span class="sent-time">{{ d.createdAt | date : "MM/dd/y hh:mm:ss" }}</span>
                                    </ng-container>
                                </ng-container>
                                <span *ngIf="ticket.status && ticket.status == 'CLOSED'" class="closed-ticket-notification">This ticket has been closed</span>
                            </div>
                            <form [formGroup]="form">
                                <div class="chat-footer">

                                        <mat-form-field class="full-width w-100" appearance="outline">
                                            <textarea
                                                    matInput
                                                    formControlName="message"
                                                    placeholder="Type here..."
                                                    cdkTextareaAutosize
                                                    cdkAutosizeMinRows="1"
                                                    cdkAutosizeMaxRows="5">
                                            </textarea>
                                            <button [disabled]="uploading" (click)="hasAttachment = !hasAttachment" type="button" mat-icon-button matSuffix>
                                                <mat-icon>attachment</mat-icon>
                                            </button>
                                            <button [disabled]="uploading" type="button" class="send-button" mat-icon-button matSuffix (click)="sendMessage()">
                                                <mat-icon>send</mat-icon>
                                            </button>
                                        </mat-form-field>
                                </div>
                                <div class="chat-footer" *ngIf="hasAttachment">
                                    <app-upload-single style="width: 100%"
                                            (fileChange)="getFileChange($event)"
                                            [accept]="'image/*,application/pdf'"
                                            [fileUrl]="fileUrl"
                                            [labelButton]="'Browse File'"
                                            [label]="'Accepted File Type Image or PDF'"
                                            [readonly]="uploading">

                                    </app-upload-single>
                                </div>
                            </form>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>